<template>
  <div>
    <el-select v-model="select">
      <el-option
        v-for="(item, index) in searchList"
        value-key="key"
        :key="item.name"
        :value="index"
        :label="item.name"
      ></el-option>
    </el-select>
    <el-input style="margin-left:10px;" v-model="input" :placeholder="placeholder"></el-input>
  </div>
</template>

<script>
export default {
  name: "select-input",
  props: {
    searchList: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      select: 0,
      input: "",
      placeholder: ""
    };
  },
  created() {
    this.placeholder = this.searchList[0].placeholder;
  },
  watch: {
    select: function(val) {
      this.placeholder = this.searchList[val].placeholder;
      this.$emit("update", this.getKeyValue());
    },
    input: function() {
      this.$emit("update", this.getKeyValue());
    }
  },
  methods: {
    getKeyValue() {
      let temp = {};
      this.searchList.forEach(item => {
        temp[item.key] = "";
      });
      temp[this.searchList[this.select].key] = this.input;
      return temp;
    },
    reset() {
      this.select= 0
      this.input= ""
    }
  }
};
</script>

<style>
</style>